import {
  useQuery,
  UseQueryOptions,
  keepPreviousData,
  UseQueryResult,
} from '@tanstack/react-query'
import { PartNumberRuleDTO } from 'declarations'

import { client } from 'services/helpers/apiConfig'

type RequisitionListQueryParamsDTO = {
  pageIndex: number
  rowsCount: number
  filterValues?: {
    supplierId: string
    partNumberClass: string
  }
  searchTerm?: string
}

type ResponseDTO = {
  part_number_rules: PartNumberRuleDTO[]
  total_rows: number
}

const usePartNumberRulesListQuery = (
  params: RequisitionListQueryParamsDTO
): UseQueryResult<ResponseDTO> => {
  return useQuery({
    queryKey: [
      'part-number-rules-list',
      params.pageIndex,
      params.rowsCount,
      params.filterValues?.supplierId,
      params.filterValues?.partNumberClass,
      params.searchTerm,
    ],
    queryFn: async () => {
      const reqParams = {
        supplier_id: params.filterValues?.supplierId,
        part_number_class: params.filterValues?.partNumberClass,
        page: params.pageIndex,
        rows: params.rowsCount,
        search_term: params.searchTerm,
      }

      const res = await client.get('/part_number_rules/list', {
        params: reqParams,
      })

      return res.data.data
    },
    placeholderData: keepPreviousData,
    staleTime: 5000,
  })
}

export { usePartNumberRulesListQuery }
